var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.offer)?_c('div',[_c('Details',{attrs:{"offer":_vm.offer},on:{"updated":_vm.offerUpdated}}),_c('FeeRanges',{attrs:{"feeConfiguration":_vm.offer,"url":_vm.url}}),_c('offer-associations',{attrs:{"offer":_vm.offer}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }